// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-5614e78f] .el-dialog .el-dialog__header{background-color:#f2f2f2;font-weight:700}", ""]);
// Exports
module.exports = exports;
